class ErrorMessageHandler {

    getCustomErrorMessageForPolicyTransaction =(error : any) =>{
        var error_Lower = error?.toLowerCase();

        if(!error_Lower){
            return "Error while applying policy transaction.";
        }
        if(error_Lower.includes('prior_policy_id_mandatory')){
            return "Prior Policy Id is mandatory for Renewal transaction type.";
        }
        else if(error_Lower.includes('transaction_effective_date_null')){
            return "Transaction effective date is missing.";
        }
        else if(error_Lower.includes('lob_not_supported')){
            return "This LOB not supported for transaction.";
        }
        else if(error_Lower.includes('transaction_already_applied')){
            return "This transaction is already applied.";
        }
        else if(error_Lower.includes('company information not available')){
            return "Company name not found.";
        }
        
        else{
            return "Error while applying policy transaction.";}

    }
}
export default ErrorMessageHandler